import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { motion } from "framer-motion";

class Overlay extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.func,
    ]),
    onDismiss: PropTypes.func,
    bgColor: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = 'initial';
  }

  handleKeyDown(event) {
    if (event.key === 'Escape' && this.props.onDismiss) {
      this.props.onDismiss();
    }
  }

  handleClick(event) {
    const clickedOnOverlay = event.target.dataset.role === 'overlay';
    if (this.props.onDismiss && clickedOnOverlay) {
      this.props.onDismiss();
    }
  }

  render() {
    const bgColor = this.props.bgColor || 'rgba(255, 255, 255, .75)';

    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1}}
        exit={{ opacity: 0 }}
        transition={{ duration: .2 }}
        data-role="overlay"
        style={{ backgroundColor: bgColor, zIndex: 1000 }}
        className="overlay fixed pin-t pin-l w-full h-full overflow-y-auto"
        onClick={this.handleClick}>
        {this.props.children}
      </motion.div>
    );
  }
}

export default  Overlay;
